import { Controller } from "@hotwired/stimulus";
import { setupTooltips } from "../../../bootstrap";

// RentVerification Resident Confirmation Form controller
export default class extends Controller {
  connect() {
    this.applicantStatus = this.element.querySelector("#rent_verification_applicant_status");
    this.landlordRelationshipDiv = this.element.querySelector("#landlord-relationship-div");
    this.landlordRelationship = this.element.querySelector("#rent_verification_relationship_to_applicant");
    this.isRentAgreementDiv = this.element.querySelector("#is-rent-agreement-div");
    this.paidRent = this.element.querySelector("#rent_verification_paid_rent");
    this.leaseConfirmations = this.element.querySelectorAll(".lease_confirmation_selections");
    this.adjustAddressDiv = this.element.querySelector("#adjust-address-fields");
    this.adjustAddressBtn = this.element.querySelector("#adjust-address-visibility-on");
    this.legitimateResidentCertificationDiv = this.element.querySelector("#legitimate-resident-certification-div");
    this.legitimateResidentCertification = this.element.querySelector(
      "#rent_verification_legitimate_resident_certification",
    );

    this.adjustAddressBtn.addEventListener("click", this.adjustAddressEventListener.bind(this));
    this.applicantStatus?.addEventListener("change", this.applicantStatusEventListener.bind(this));
    this.landlordRelationship?.addEventListener("change", this.landlordRelationshipEventListener.bind(this));

    this.syncFormWithResidentStatus();
    this.syncFormWithLandlordRelationship();
    setupTooltips();
  }

  hide(element) {
    if (!element) return;

    element.style.setProperty("display", "none");
  }

  show(element) {
    if (!element) return;

    element.style.setProperty("display", "inline-block", "important");
  }

  showBlock(element) {
    if (!element) return;

    element.style.setProperty("display", "block", "important");
  }

  adjustAddressEventListener(_e) {
    this.showBlock(this.adjustAddressDiv);
  }

  applicantStatusEventListener(e) {
    this.syncFormWithResidentStatus();
    this.syncFormWithLandlordRelationship();
  }

  landlordRelationshipEventListener(e) {
    this.syncFormWithResidentStatus();
    this.syncFormWithLandlordRelationship();
  }

  disconnect() {
    this.applicantStatus?.removeEventListener("change", (e) => this.syncFormWithResidentStatus());
  }

  syncFormWithResidentStatus() {
    if (!this.applicantStatus) return;

    let value = this.applicantStatus.value;
    if (value === "UNKNOWN_RESIDENT" || value === "LOST_RECORDS") {
      this.hide(this.landlordRelationshipDiv);
      this.hide(this.adjustAddressBtn);
      this.hide(this.adjustAddressDiv);
      this.hide(this.legitimateResidentCertificationDiv);
      if (this.landlordRelationship) {
        this.landlordRelationship.required = false;
      }
      if (this.legitimateResidentCertification) {
        this.legitimateResidentCertification.required = false;
      }
      return;
    }

    this.show(this.adjustAddressBtn);
    if (!value) return;

    if (this.landlordRelationship) {
      this.showBlock(this.landlordRelationshipDiv);
      this.landlordRelationship.required = true;
    }
  }

  syncFormWithLandlordRelationship() {
    if (!this.applicantStatus) return;

    let residentStatusValue = this.applicantStatus.value;
    if (!this.landlordRelationship) return;
    let value = this.landlordRelationship.value;

    if (
      !value ||
      value === "SELF" ||
      !residentStatusValue ||
      residentStatusValue == "UNKNOWN_RESIDENT" ||
      residentStatusValue === "LOST_RECORDS"
    ) {
      this.hide(this.isRentAgreementDiv);
      this.hide(this.legitimateResidentCertificationDiv);
      if (this.paidRent) {
        this.paidRent.required = false;
      }
      if (this.leaseConfirmations) {
        this.leaseConfirmations.forEach((e, i) => {
          e.required = false;
        });
      }
      if (this.legitimateResidentCertification) {
        this.legitimateResidentCertification.required = false;
      }
    } else {
      this.showBlock(this.isRentAgreementDiv);
      if (this.paidRent) {
        this.paidRent.required = true;
      }
      if (this.leaseConfirmations) {
        this.leaseConfirmations.forEach((e, i) => {
          e.required = true;
        });
      }

      // Show certification only for FAMILY or FRIEND relationships
      if (value === "FAMILY" || value === "FRIEND") {
        this.showBlock(this.legitimateResidentCertificationDiv);
        if (this.legitimateResidentCertification) {
          this.legitimateResidentCertification.required = true;
        }
      } else {
        this.hide(this.legitimateResidentCertificationDiv);
        if (this.legitimateResidentCertification) {
          this.legitimateResidentCertification.required = false;
        }
      }
    }
  }
}
